import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const nutritionProgressesApi = api
  .enhanceEndpoints({
    addTagTypes: ["nutritionProgress"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      nutritionProgresses: builder.query({
        query: ({ userId, status }) => ({
          url: `nutrition-progresses`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["nutritionProgress"],
      }),
      nutritionProgress: builder.query({
        query: ({ userId, status, id }) => ({
          url: `nutrition-progresses/${id ?? "0"}`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            status,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["nutritionProgress"],
      }),
    }),
  });

export const { useNutritionProgressesQuery, useNutritionProgressQuery } =
  nutritionProgressesApi;
